import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { Controller, useFormContext } from 'react-hook-form';
import { PaymentFormValues } from 'src/pages/payment-msi/PaymentMsiV2/PaymentMsiV2';
import { PaymentPlanField } from 'src/pages/payment-msi/PaymentMsiV2/components/PaymentPlanField';
import { PaymentSectionId } from 'src/pages/payment-msi/PaymentMsiV2/constants';
import { PaymentPlanOption } from 'src/pages/payment-msi/PaymentMsiV2/utils';
import { AppTheme } from 'src/themes/muiTheme';

const paymentPlansSectionStyles = {
  paymentPlan: (theme: AppTheme) => {
    const mobileMaxSize = theme.breakpoints.values.sm + 1;
    const mobile = theme.breakpoints.down(mobileMaxSize);

    return {
      marginBottom: '40px',
      [mobile]: {
        marginBottom: '30px',
      },
    };
  },
  paymentPlanTitle: (theme: AppTheme) => {
    const mobileMaxSize = theme.breakpoints.values.sm + 1;
    const mobile = theme.breakpoints.down(mobileMaxSize);
    const tabletMaxSize = theme.breakpoints.values.lg + 1;
    const tablet = theme.breakpoints.down(tabletMaxSize);

    return {
      marginBottom: '24px',
      [tablet]: {
        fontSize: '24px',
        lineHeight: '34px',
      },
      [mobile]: {
        marginBottom: '30px',
      },
    };
  },
};

interface PaymentPlansSectionProps {
  paymentPlanOptions: PaymentPlanOption[];
}

export function PaymentPlansSection({
  paymentPlanOptions,
}: PaymentPlansSectionProps) {
  const { control } = useFormContext<PaymentFormValues>();

  return (
    <Box
      component={'article'}
      sx={paymentPlansSectionStyles.paymentPlan}
      id={PaymentSectionId.PaymentPlans}
    >
      <Typography
        sx={paymentPlansSectionStyles.paymentPlanTitle}
        component={'h3'}
        variant={'h5'}
      >
        Choose your payment type
      </Typography>
      <Controller
        control={control}
        name="paymentPlan"
        render={({ field }) => {
          return (
            <PaymentPlanField
              name={field.name}
              value={field.value}
              onChange={field.onChange}
              paymentOptions={paymentPlanOptions}
            />
          );
        }}
      />
    </Box>
  );
}
